import React, { Component, PropTypes } from 'react';

export const toSearchString = (searchParams = {}) => {
    return Object.keys(searchParams).map(key =>
        `${key}=${encodeURIComponent(searchParams[key])}`
    ).join('&');

};

export const createMailtoLink = (email, headers) => {
    let link = `mailto:${email}`;
    if (headers) {
        link += `?${toSearchString(headers)}`;
    }
    return link;
};

const defaultHeaders = {};
defaultHeaders.subject = "Feature Request";
defaultHeaders.body = "As a Customer of envimation I want ...";

class ContactUs extends Component {

    render () {
        return this.renderLink();
    }

    renderLink () {
        const { email, headers, children, ...others } = this.props;
        return (
            <a target="_blank" href={createMailtoLink(email, headers)} {...others}>
                {children}
            </a>
        );
    }
}

ContactUs.propTypes = {
    children: PropTypes.node.isRequired,
    email: PropTypes.string,
    headers: PropTypes.object,
};

ContactUs.defaultProps = {
    headers: defaultHeaders,
    email: "automation@envimate.com"
};

export default ContactUs;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/ContactUs.js
 **/